<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import { Table } from 'sveltestrap'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import {withdrawals} from 'src/components/cabinet/#services/withdrawals'
    import {clickOutside} from 'src/components/#common/helpers/clickOutside'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'
    import arrow from 'src/components/cabinet/#assets/arrow.png'
    import {roundNumber} from 'src/components/#common/helpers'

    let currentPage = 0
    let perPage = 25
    let startDate
    let endDate
    let loadingTransactions = []
    let recipientAddress
    let emailAddress
    let supportId
    let status = []
    let maxDate = new Date()
    let dd = String(maxDate.getDate()).padStart(2, '0')
    let mm = String(maxDate.getMonth() + 1).padStart(2, '0')
    let yyyy = maxDate.getFullYear()
    let selectedStatuses = []
    let classDropdownOpen = false
    maxDate = yyyy+'-'+mm+'-'+dd

    loadingTransactions.length = perPage

    filter()

    function changeStatus(status) {
        currentPage = 0
        if (status == 'all') {
            selectedStatuses = []
        } else {
            if (!selectedStatuses.includes(status)) {
                selectedStatuses = [...selectedStatuses, status]
            } else {
                selectedStatuses = selectedStatuses.filter(item => item !== status)
            }
        }
    }

    function filter() {
        withdrawals.send({ data: {
            statuses: selectedStatuses.length ? selectedStatuses : undefined,
            recipientAddress,
            email: emailAddress,
            userId: supportId,
            page: currentPage + 1,
            perPage,
            startDate,
            endDate
        }})
        $withdrawals.value
    }

    function reset() {
        recipientAddress = undefined
        selectedStatuses = []
        startDate = undefined
        endDate = undefined
        emailAddress = undefined
        supportId = undefined
        currentPage = 0
        filter()
    }

    $:currentPage,perPage,filter()
</script>

<svelte:head>
    <title>Withdrawals</title>
</svelte:head>

<MainLayout title="Withdrawals">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <div class="buttons">
                    <div class="pc-line">
                        <div class="dropdown" use:clickOutside={() => {classDropdownOpen = false}} class:active={classDropdownOpen}>
                            <div class="dropdown-selected">
                                <div class="need-select" on:click={() => {classDropdownOpen = !classDropdownOpen}}>
                                    Choose a statuses<img src="{arrow}" class="arrow" alt="">
                                </div>
                            </div>
                            <div class="dropdown-list">
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeStatus('all')} checked={!selectedStatuses.length} disabled={!selectedStatuses.length}>All
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeStatus('success')} checked={selectedStatuses.includes('success')}>Success
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeStatus('onApproving')} checked={selectedStatuses.includes('onApproving')}>On approving
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeStatus('notApproved')} checked={selectedStatuses.includes('notApproved')}>Not approved
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeStatus('onConfirmation')} checked={selectedStatuses.includes('onConfirmation')}>On confirmation
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeStatus('confirmed')} checked={selectedStatuses.includes('confirmed')}>Confirmed
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeStatus('notConfirmed')} checked={selectedStatuses.includes('notConfirmed')}>Not confirmed
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="pc-line">
                        <input type="text" bind:value={recipientAddress} class="form-control wallet-address" placeholder="Enter wallet">
                    </div>
                    <div class="pc-line">
                        <input type="text" bind:value={supportId} class="form-control wallet-address" placeholder="Support ID">
                    </div>
                    <div class="pc-line">
                        <input type="text" bind:value={emailAddress} class="form-control wallet-address" placeholder="Enter Email">
                    </div>
                    <div class="pc-line">
                        <input type="date" bind:value={startDate} class="form-control" max="{maxDate}">
                    </div>
                    <div class="pc-line">
                        <input type="date" bind:value="{endDate}" class="form-control" max="{maxDate}">
                    </div>
                    <div class="pc-line">
                        <button class="btn btn-primary btn-filter" on:click={filter}>Filter</button>
                        <button class="btn btn-secondary" on:click={reset}>Reset</button>
                    </div>
                </div>
                {#if $withdrawals.hasValue}
                    <PerPage
                        bind:perPage={perPage}
                        disabled={$withdrawals.loading || $withdrawals.loading}
                        totalCount={$withdrawals.value.totalCount}
                    />
                {/if}
                <div class="transactions-list">
                    <Table bordered striped responsive>
                        <thead>
                        <tr>
                            <td class="text-center">Status</td>
                            <td class="text-center">Amount</td>
                            <td class="text-center">Network</td>
                            <td class="text-center">User</td>
                            <td class="text-center">Wallet</td>
                            <td class="text-center">Date</td>
                        </tr>
                        </thead>
                        <tbody>
                        {#if $withdrawals.loading}
                            {#each {length:perPage} as item}
                                <tr>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                </tr>
                            {/each}
                        {:else if $withdrawals.error || !$withdrawals.hasValue }
                            <tr>
                                <td class="text-center" colspan="6">Something went wrong. Try refreshing the page.</td>
                            </tr>
                        {:else}
                            {#each $withdrawals.value.data as { status, userId, amount, network, currency, fee, recipientAddress, createdAt }}
                                <tr>
                                    <td class="text-center">
                                        {#if status === 'onApproving' || status === 'approved' || status === 'confirmed'}
                                            <span class="status-pending">Pending</span>
                                        {:else if status === 'onConfirmation'}
                                            <span class="status-sending">Email sent</span>
                                        {:else if status === 'notApproved' || status === 'notConfirmed' || status === 'error'}
                                            <span class="status-returned">Returned</span>
                                        {:else if status === 'success'}
                                            <span class="status-success">Success</span>
                                        {:else}
                                            {status}
                                        {/if}
                                    </td>
                                    <td class="text-center">{roundNumber(+amount - +fee)} {currency === 'WLIS' ? 'LIS' : currency}</td>
                                    <td class="text-center">{network || 'near'}</td>
                                    <td class="text-center">
                                        {#if userId}
                                            <a href="profile/{userId}" class="reason" target="_blank" rel="noreferrer">{userId}</a>
                                        {/if}
                                    </td>
                                    <td class="text-center">
                                        {#if network === 'polygon'}
                                            {#if recipientAddress}
                                                <a href="https://polygonscan.com/address/{recipientAddress}" class="address notranslate" target="_blank" rel="noreferrer">
                                                    {recipientAddress.slice(0,7)}...{recipientAddress.slice(-7)}
                                                </a>
                                            {/if}
                                        {:else}
                                            {#if recipientAddress}
                                                <a href="https://nearblocks.io/token/token.v1.realisnetwork.near?a={recipientAddress}" class="address notranslate" target="_blank" rel="noreferrer">
                                                    {#if recipientAddress.length >= 20}
                                                        {recipientAddress.slice(0,7)}...{recipientAddress.slice(-7)}
                                                    {:else}
                                                        {recipientAddress}
                                                    {/if}
                                                </a>
                                            {:else}
                                                <span class="address notranslate">
                                                    {#if recipientAddress.length >= 20}
                                                        {recipientAddress.slice(0,7)}...{recipientAddress.slice(-7)}
                                                    {:else}
                                                        {recipientAddress}
                                                    {/if}
                                                </span>
                                            {/if}
                                        {/if}
                                    </td>
                                    <td class="text-center">{new Date(createdAt).toLocaleString()}</td>
                                </tr>
                            {:else}
                                <tr>
                                    <td class="text-center" colspan="5">No items</td>
                                </tr>
                            {/each}
                        {/if}
                        </tbody>
                    </Table>
                    {#if $withdrawals.hasValue}
                        <PerPage
                            bind:perPage={perPage}
                            disabled={$withdrawals.loading || $withdrawals.loading}
                            totalCount={$withdrawals.value.totalCount}
                        />
                        <Pagination
                            bind:currentPage={currentPage}
                            totalCount={$withdrawals.value.totalCount}
                            {perPage}
                            disabled={$withdrawals.loading || $withdrawals.loading}
                        />
                    {/if}
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .wallet-address {
        display: inline-block;
        width: auto;
    }

    .dropdown {
        background: white;
        width: 200px;
        border-radius: 3px;
        position: relative;
        display: inline-block;
        z-index: 3;
        border: 1px solid #ced4da;
    }

    .dropdown.sort-by-dropdown {
        width: 180px;
    }

    .dropdown-selected {
        padding: 10px;
        font-size: 14px;
        color: #212529;
        font-weight: 300;
        position: relative;
        cursor: pointer;
        user-select: none;
    }

    .arrow {
        position: absolute;
        transform: rotate(180deg);
        right: 11px;
        top: 50%;
        margin-top: -10px;
        transition: .15s;
        filter: invert(1);
        opacity: 0.8;
    }

    .dropdown.active .arrow {
        transform: rotate(0deg);
    }

    .need-select {
        padding: 6px 15px;
        height: 36px;
        margin: -10px;
        font-size: 1rem;
    }

    .dropdown-list {
        display: none;
        padding: 12px;
        position: absolute;
        background: white;
        width: 100%;
        border-radius: 3px;
        margin-top: 10px;
        border: 1px solid #ced4da;
        z-index: 2;
        box-shadow: 0 2px 5px 0 #0a0a0a2e;
    }

    .dropdown.active .dropdown-list {
        display: block;
    }

    .dropdown-list .checkbox,
    .dropdown-list .item {
        font-size: 16px;
        color: #212529;
        font-weight: 400;
        padding: 3px 0;
        display: block;
        cursor: pointer;
        user-select: none;
        transition: .25s;
    }

    .dropdown-list .checkbox:hover,
    .dropdown-list .item:hover {
        color: #212529;
    }

    .dropdown-list .checkbox:last-child,
    .dropdown-list .item:last-child {
        margin-bottom: 0;
    }

    .checkbox input[type="checkbox"] {
        width: 1em;
        height: 1em;
        margin-top: 3px;
        vertical-align: top;
        margin-right: 10px;
        background: none;
        border-radius: 2px;
        border: 1px solid #A0AEC0;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
    }

    .checkbox input[type="checkbox"]:checked {
        background-color: #FF5D1C;
        border-color: #FF5D1C;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");
    }

    .buttons {
        margin-bottom: 15px;
    }

    .buttons .btn {
        margin-left: 5px;
    }

    .transaction-loading {
        height: 24px;
        width: 100%;
        display: block;
    }

    .btn-primary.btn-filter {
        padding: 8px 20px;
    }

    .form-select {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    input[type="date"] {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    .date-label {
        padding: 0 5px;
        line-height: 38px;
        font-weight: 500;
    }

    .btn.btn-secondary {
        padding: 10px 20px;
        font-size: 14px;
        line-height: normal;
        border: 0;
        box-shadow: none;
    }

    .btn.active {
        background: #FF5D1C;
    }

    .pc-line {
        display: inline-block;
        margin-bottom: 10px;
        vertical-align: top;
    }

    .status-success {
        color: #27AE60;
    }

    .status-pending {
        color: #ff9800;
    }

    .status-sending {
        color: #ff9800;
        margin-top: -15px;
        font-size: 17px;
    }

    .status-returned {
        color: #da4848;
    }

    .buttons {
        margin-bottom: 15px;
    }

    .buttons .btn {
        margin-left: 5px;
    }

    .transaction-loading {
        height: 24px;
        width: 100%;
        display: block;
    }

    .btn-primary.btn-filter {
        padding: 8px 20px;
    }

    .form-select {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    input[type="date"] {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    .date-label {
        padding: 0 5px;
        line-height: 38px;
        font-weight: 500;
    }

    .btn.btn-secondary {
        padding: 10px 20px;
        font-size: 14px;
        line-height: normal;
        border: 0;
        box-shadow: none;
    }

    .btn.active {
        background: #FF5D1C;
    }

    .pc-line {
        display: inline-block;
        margin-bottom: 10px;
    }

    @media(max-width: 767px) {
        .pc-line {
            display: block;
        }

        .pc-line .btn {
            margin-left: 0;
            width: 100%;
        }

        .date-label {
            font-size: 14px;
        }

        .btn-filter {
            margin-bottom: 10px;
        }

        .pc-line {
            display: block;
        }

        .pc-line .btn {
            margin-left: 0;
            width: 100%;
        }

        .date-label {
            font-size: 14px;
        }

        .btn-filter {
            margin-bottom: 10px;
        }
    }
</style>
